export default "__VITE_ASSET__BZt$6tnY__"